import Navbar from '@/components/Landing/Navbar';
import Footer from '@/components/Landing/Footer';

export default function PrivacyPage() {
  return (
    <div className="landing-layout">
      <Navbar />
      <main style={{ paddingTop: '70px' }}>
        <section className="px-6 py-20 sm:py-24 bg-background">
          <div className="max-w-3xl mx-auto">
            <p className="text-muted-foreground uppercase tracking-[0.2em] text-xs font-medium mb-4">Legal</p>
            <h1 className="text-foreground font-serif mb-12" style={{ fontSize: 'clamp(30px, 4vw, 50px)', lineHeight: 1.15, fontWeight: 700 }}>
              Privacy Policy
            </h1>

            <div className="space-y-10 text-foreground/90 text-lg" style={{ lineHeight: 2 }}>
              <section>
                <h2 className="text-foreground font-serif text-2xl mb-4">Who we are</h2>
                <p>
                  Foreman ("we", "us", "our") is an AI-powered business automation platform for trade businesses.
                  Our website is <a href="https://www.askforeman.co.uk" className="text-primary hover:underline">www.askforeman.co.uk</a>.
                  If you have questions about this policy, contact us at{' '}
                  <a href="mailto:owen@askforeman.co.uk" className="text-primary hover:underline">owen@askforeman.co.uk</a>.
                </p>
              </section>

              <section>
                <h2 className="text-foreground font-serif text-2xl mb-4">What data we collect</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Account information:</strong> name, email address, phone number, and company name when you sign up.</li>
                  <li><strong>Usage data:</strong> chat messages, workflow configurations, and CRM queries you run through Foreman.</li>
                  <li><strong>Technical data:</strong> browser type, IP address, and device information collected automatically.</li>
                  <li><strong>Cookies:</strong> we use essential cookies for authentication. We do not use advertising or tracking cookies.</li>
                </ul>
              </section>

              <section>
                <h2 className="text-foreground font-serif text-2xl mb-4">How we use your data</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>To provide and improve the Foreman service.</li>
                  <li>To authenticate you and keep your account secure.</li>
                  <li>To process your CRM queries and deliver AI-generated responses.</li>
                  <li>To send service-related communications (not marketing).</li>
                </ul>
              </section>

              <section>
                <h2 className="text-foreground font-serif text-2xl mb-4">Data storage and security</h2>
                <p>
                  Your data is stored on secure servers hosted by Amazon Web Services (AWS) in the EU (London region, eu-west-2).
                  We use encryption in transit (TLS) and at rest. CRM credentials are stored using industry-standard encryption.
                </p>
              </section>

              <section>
                <h2 className="text-foreground font-serif text-2xl mb-4">Third-party services</h2>
                <p>We use the following third-party services to operate Foreman:</p>
                <ul className="list-disc pl-6 space-y-2 mt-3">
                  <li><strong>AWS:</strong> cloud hosting and database services.</li>
                  <li><strong>AWS Cognito:</strong> authentication and identity management.</li>
                  <li><strong>OpenAI / Anthropic:</strong> AI model providers for chat and analysis features.</li>
                </ul>
                <p className="mt-3">We do not sell your data to any third party.</p>
              </section>

              <section>
                <h2 className="text-foreground font-serif text-2xl mb-4">Your rights</h2>
                <p>Under UK GDPR, you have the right to:</p>
                <ul className="list-disc pl-6 space-y-2 mt-3">
                  <li>Access the personal data we hold about you.</li>
                  <li>Request correction or deletion of your data.</li>
                  <li>Object to or restrict processing of your data.</li>
                  <li>Request a copy of your data in a portable format.</li>
                </ul>
                <p className="mt-3">
                  To exercise any of these rights, email{' '}
                  <a href="mailto:owen@askforeman.co.uk" className="text-primary hover:underline">owen@askforeman.co.uk</a>.
                </p>
              </section>

              <section>
                <h2 className="text-foreground font-serif text-2xl mb-4">Data retention</h2>
                <p>
                  We retain your account data for as long as your account is active. Chat history and session data
                  may be retained for up to 12 months for service improvement purposes. You can request deletion
                  at any time.
                </p>
              </section>

              <section>
                <h2 className="text-foreground font-serif text-2xl mb-4">Changes to this policy</h2>
                <p>
                  We may update this privacy policy from time to time. Any changes will be posted on this page.
                  This policy was last updated on 13 March 2026.
                </p>
              </section>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
